export const DIVIDER_DEFAULTS = {
  margin: '0px 0px 0px 0px',
};
